import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings';
import {ISettingsParams} from '../../domain/utils/settings.utils';
import {DataType, SettingTypeMetadata} from '@wix/editor-platform-ooi-metadata-resolver';
import type {TranslationFunction} from 'i18next';
import {CartParamNames} from '../../common/constants';

export type ICartPublicData = Partial<{[k in keyof ISettingsParams<typeof settingsParams>]: string | {}}>;

export const settingsParams = {
  [CartParamNames.CART_TITLE]: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('cart.shopping_cart_title'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.shopping_cart_title'),
      },
    }),
  },
  [CartParamNames.CART_EMPTY_CART]: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('cart.empty_cart_title'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.empty_cart_title'),
      },
    }),
  },
  [CartParamNames.CART_CONTINUE_SHOPPING_LINK]: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('cart.continue_shopping'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.continue_shopping'),
      },
    }),
  },
  [CartParamNames.CART_CONTINUE_SHOPPING_LINK_OBJECT]: {
    type: SettingsParamType.Object,
  },
  [CartParamNames.CART_ADD_NOTE_LINK]: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('cart.buyer_note_add_button_label'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.buyer_note_add_button_label'),
      },
    }),
  },
  [CartParamNames.CART_INSTRUCTIONS_TEXT]: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('cart.buyer_note_placeholder'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.buyer_note_placeholder'),
      },
    }),
  },
  [CartParamNames.CART_ADD_PROMO_CODE_LINK]: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('cart.coupon_add_button_label'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.coupon_add_button_label'),
      },
    }),
  },
  [CartParamNames.CART_BUTTON_TEXT]: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}: {t: TranslationFunction}) => t('cart.secure_checkout'),
    inheritFromAppScope: true,
    metadata: ({t}: {t: TranslationFunction}): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('cart.secure_checkout'),
      },
    }),
  },
  [CartParamNames.CART_V2_DISCLAIMER]: {
    type: SettingsParamType.String,
    getDefaultValue: (): null => null,
    inheritFromAppScope: true,
    metadata: (): SettingTypeMetadata => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: null,
      },
    }),
  },
};

export default createSettingsParams<Omit<ISettingsParams<typeof settingsParams>, 'CART_CONTINUE_SHOPPING_LINK_OBJECT'>>(
  settingsParams
);
